/**
 * Runtime booking module gate (business_info.booking_enabled).
 * Replaces build-time BOOKING_UI_ENABLED for tenant-facing UI and POS handoffs.
 */
export function isBookingFeatureActive (businessInfo) {
  return !!businessInfo?.booking_enabled
}
